var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessionSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21436 12.5H13.2144M18.2144 6.66663H3.21436M14.0477 1.66663V4.16663M7.38102 1.66663V4.16663M7.21436 18.3333H14.2144C15.6145 18.3333 16.3146 18.3333 16.8493 18.0608C17.3197 17.8211 17.7022 17.4387 17.9419 16.9683C18.2144 16.4335 18.2144 15.7334 18.2144 14.3333V7.33329C18.2144 5.93316 18.2144 5.2331 17.9419 4.69832C17.7022 4.22791 17.3197 3.84546 16.8493 3.60578C16.3146 3.33329 15.6145 3.33329 14.2144 3.33329H7.21436C5.81422 3.33329 5.11416 3.33329 4.57938 3.60578C4.10897 3.84546 3.72652 4.22791 3.48684 4.69832C3.21436 5.2331 3.21436 5.93316 3.21436 7.33329V14.3333C3.21436 15.7334 3.21436 16.4335 3.48684 16.9683C3.72652 17.4387 4.10897 17.8211 4.57938 18.0608C5.11416 18.3333 5.81422 18.3333 7.21436 18.3333Z",
    stroke: "#0054B6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionSelected);
export default __webpack_public_path__ + "static/media/SessionSelected.9cab2079f0d1480ca8b1163ae1200307.svg";
export { ForwardRef as ReactComponent };